import React, { useContext } from 'react'
import styles from './Balance.module.sass'
import config from '../../config'
import { Web3Context } from '../../contexts/Web3Context'

const Balance = () => {
  const { defaultAccountBalance } = useContext(Web3Context)

  const prep = (amount) => {
    return parseFloat(amount).toFixed(4).replace(/0+$/, '').replace(/\.$/, '') || '0'
  }

  return (
    <>
      <span className={styles.currency}>{prep(defaultAccountBalance)}&nbsp;{config.symbolName}</span>
    </>
  )
}

export default Balance
